// @ts-nocheck

import React, { useEffect, useMemo, useState } from 'react';

import useMergeProps from '../../../hooks/useMergeProps';
import { storage } from '../../../utils';
import MPWelcome from '../components/common/MPWelcome';
import { MPWelcomeStorage } from '../constants/runtime';
import { useMPModalContext } from '../contexts/MPModalContext';
import { useMPViewContext } from '../contexts/MPViewContext';

const MPWelcomeContainer = () => {
  const { setFixScroll } = useMPViewContext();
  const { setDisableScrollView } = useMPModalContext();
  const [hasAlreadyWelcomed, setHasAlreadyWelcomed] = useState(storage.localStorage.load(MPWelcomeStorage));

  useEffect(() => {
    if (!hasAlreadyWelcomed) {
      setDisableScrollView(true);
      setFixScroll(true);
    } else {
      setDisableScrollView(false);
      setFixScroll(false);
    }
  }, [hasAlreadyWelcomed, setDisableScrollView, setFixScroll]);

  const actionsProps = useMemo(
    () => ({
      onClick: () => {
        storage.localStorage.save(MPWelcomeStorage, true);
        setHasAlreadyWelcomed(true);
      },
    }),
    [],
  );

  const enhancedProps = useMergeProps({ actionsProps });

  return !hasAlreadyWelcomed ? <MPWelcome {...enhancedProps} /> : null;
};

export default MPWelcomeContainer;
